<diy-data #data *ngFor="let question of questions" [question]="question"></diy-data>
<br/>
